<style scoped lang="scss">
  @import 'src/scss/vars';    //от папки со сборкой
  .slide-main {
    overflow: hidden;

    display: flex;
    align-items: center;
    flex-flow: column nowrap;
    .img-wrapper {
      /*outline: 1px solid darkred;*/
      max-width: 100%;
      max-height: 100%;
      overflow: hidden;
      flex-grow: 1;
      width: 100%;
      position: relative;
      cursor: grab;
      img {

        pointer-events: none;  //чтобы работал pan вместо drag
                              
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        // вообще-то должно быть center center, 
        // но,наверное, из за того что transform: translate(-50%, -50%) срабатывает 0 0 
        transform-origin: 0 0;
        opacity: 0;
        transition: opacity $timeShort;
        &.flickity-lazyloaded,
        &.flickity-lazyerror {
          opacity: 1;
        }
      }
      img + .cool-loader {
        opacity: 1;
        transition: opacity $timeShort;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      img.flickity-lazyloaded + .cool-loader,
      img.flickity-lazyerror + .cool-loader{
        opacity: 0;
      }
    }
    .texts {
      text-align: center;
      .header {
        /*margin-top: var(--sizeCell);*/
        padding-right: calc( 4 * var(--sizeCell));
        padding-left: calc( 4 * var(--sizeCell));
        height: calc( 4 * var(--sizeCell));
        margin: 0;
        display: flex;
        align-items: center;
      }
      .desc {
        margin-top: 0.7em;
        padding-right: calc( 16 * var(--px));
        padding-left: calc( 16 * var(--px));
      }
    }
    transition: opacity $timeMed;
    opacity: 0;
    &.is-selected {
      opacity: 1;
    }
  }
</style>

<template>
    <div class="slide-main">
  
      <div class="texts">
        <p class="header h5 color-close-to-bg-light">{{image.title}}</p>
      </div>
  
      <div class="img-wrapper" ref="nImgWrapper">
        <img :data-flickity-lazyload="image.src" ref="nImg">
        <cool-loader-vue></cool-loader-vue>
      </div>
      <div class="texts">
        <p class="desc color-close-to-bg-light">{{image.description}}</p>
      </div>
  
  
    </div>
</template>

<script>
    import CoolLoaderVue from '../components/cool-loader-vue'
    import Hammer from 'hammerjs'
    import SmartTransformer from '../JE/SmartTransformer';
    import debounce from 'lodash/debounce'
    
    import calculationMixin from './slide-main-calculations.mixin'
    import panListenersMixin from './slide-main-pan-listeners.mixin'
    import pinchListenersMixin from './slide-main-pinch-listeners.mixin'
    import rewritersMixin from './slide-main-rewriters.mixin'

    /**
     * emits:
     * needToDisableFlickityPan - нужен чтобы отключать pan-жест сверху на слайдере когда начался зум
     * needToEnableFlickityPan  - нужен чтобы снова подключать pan-жест сверху на слайдере когда закончился зум
     */
    export default {
        components: {
          CoolLoaderVue,
        },
        mixins: [
          calculationMixin,
          panListenersMixin,
          pinchListenersMixin,
          rewritersMixin,
        ],
        props: {
  
          image: {
            type: Object,
          },
          // нужна чтобы ловить события не на слайде а целиком на галерее
          // пока-что не применяется:
          // -сыпет ошибки что $ref не найден
          // - c ней же маштабирование работает для всех слайдов сразу - а это не хорошо
          gallery: {
            // type: Object,
          }
        },
        data(){
          return {
            // хаммер-менеджер. Присваивается при монтировании
            hm: null,
            // smart-transformer для css-трансформов
            transformer: null,
          }
        },
        methods: {
          
          /**
           * Можно менять слайды 
           * если scale == 1 
           * ~~или если ширина изображения не больше ширины обертки~~
           * return bool
           */
          _canUserPanSlider(){
            let result = false;
            if (this._isImageFitsToWrapper())  {
              result = true
            } 
            return result;
          },
          /**
           * 
           * @param he - hammer event
           */

          

          _prepapeAndZoom(newScale){
            this._zoom(newScale);
            this.lastScale = this._getScale();
          },
          _checkSliderLock(){
            if (this._canUserPanSlider()) {
              this._unlockFlickityPan();
              // console.log('unlock')
            } else {
              this._lockFlickityPan();
            }
          },
          _lockFlickityPan(){
            this.$emit('NeedToDisableFlickityPan')
          },
          _unlockFlickityPan(){
            this.$emit('needToEnableFlickityPan')
          },



          _createTransformer(){
            this.transformer = new SmartTransformer({
              node: this.$refs.nImg,
              initValues: {
                translateX: "-50%",
                translateY: "-50%",
              }
            });
          },
          _createHammerManager(){

            // задел на будущее - нужно будет чтобы реагировало на события не по верхнему слайдеру,а по всей галерее.
            // возможно их будет проще ловить на body? Не - вдруг галерея начнет занимать не весь экран.
            // this.hm = new Hammer.Manager(this.gallery, {

            this.hm = new Hammer.Manager(this.$refs.nImgWrapper, {
              domEvents: true,
            });
            let panRec = new Hammer.Pan({
              direction: Hammer.DIRECTION_ALL
            });
            let pinchRec = new Hammer.Pinch({
              enable: true,
              direction: Hammer.DIRECTION_HORIZONTAL,
            },);
            pinchRec.recognizeWith(panRec);
            let tapRec = new Hammer.Tap();
            let pressRec = new Hammer.Press();
            this.hm.add(panRec);
            this.hm.add(pinchRec);
            this.hm.add(tapRec);
            this.hm.add(pressRec);
          },
          _attachListeners(){
            // зумирование
            this.hm.on("pinch", this._listenerPinch);
            this.hm.on("pinchstart", this._listenerPinchStart);
            this.hm.on("pinchend", this._listenerPinchEnd);

            this.$refs.nImgWrapper.addEventListener('wheel', this._listenerWhell)
            
            this.hm.on("tap press", this.resetTransform);
            // зумирование


            // панорамирование
            this.hm.on("panmove", this._listenerPanMove);
            
            // удобно для дебага
            // this.hm.on("panmove", debounce(this._listenerPanUp, 150, {'leading': true, 'trailing': false}));
            
            // панорамирование end
          },
        },
        mounted(){
          this._createTransformer();
          this._createHammerManager();
          this._attachListeners();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/slide-main.vue